import { DataBean } from "../DataBean";

export class PriceListItem extends DataBean {

    public async getPriceListItemCatalogByPriceList(idPriceList: any, idStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPriceListItemCatalogByPriceList_Number_Number", [idPriceList, idStore]);
    }

    public async getPriceListItemCatalog(idPriceList: number, idProduct: number, idStore: number, regexStr: string, page: number, recordsPerPage:number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getPriceListItemCatalog_Number_Number_Number_String_Number_Number", [idPriceList, idProduct, idStore, regexStr, page, recordsPerPage]);
    }

    public async addPriceListItem(idPriceList: any, idProduct: any, idStore: any, priceValue: any, costValue: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.inventory.PriceListItem_addPriceListItem_Number_Number_Number_Number_Number", [idPriceList, idProduct, idStore, priceValue, costValue]);
    }

}